import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "marketing-promotion-banner";

const GET_ALL_MARKETING_PROMOTION_BANNER_URL = `${prefix}/all`;
const GET_MARKETING_PROMOTION_BANNER_URL = `${prefix}/get`;
const CREATE_MARKETING_PROMOTION_BANNER_URL = `${prefix}/create`;
const UPDATE_MARKETING_PROMOTION_BANNER_BY_ID_URL = `${prefix}/update-by-id`;
const DELETE_MARKETING_PROMOTION_BANNER_BY_ID_URL = `${prefix}/delete-by-id`;

/**
 * @func getAllMarketingPromotionBanner
 * @desc get all promotion banner data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} promotion banner array
 */
export const getAllMarketingPromotionBanner = async (queryParams, signal) => {
    try {
        const { data, status } = await axios.get(GET_ALL_MARKETING_PROMOTION_BANNER_URL, {
            params: queryParams,
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getAllMarketingPromotionBanner");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getAllMarketingPromotionBanner */

/**
 * @func getMarketingPromotionBanner
 * @desc get promotion banner data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} promotion banner array
 */
export const getMarketingPromotionBanner = async (signal) => {
    try {
        const { data, status } = await axios.get(GET_MARKETING_PROMOTION_BANNER_URL, {
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getMarketingPromotionBanner");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getMarketingPromotionBanner */

/**
 * @func createMarketingPromotionBanner
 * @desc create new promotion banner
 * @author izeberg
 * @param {Object} body - create promotion banner body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} create status
 */
export const createMarketingPromotionBanner = async (body, signal) => {
    try {
        const { status } = await axios.post(CREATE_MARKETING_PROMOTION_BANNER_URL, body, {
            signal,
        });
        if (status === 201) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "createMarketingPromotionBanner");
        if (err) throw err;
        return undefined;
    }
};
/** End @func createMarketingPromotionBanner */

/**
 * @func updateMarketingPromotionBannerById
 * @desc update promotion banner by id
 * @author izeberg
 * @param {number} id - promotion banner id
 * @param {Object} body - update promotion banner body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {boolean} update status
 */
export const updateMarketingPromotionBannerById = async (id, body, signal) => {
    try {
        const { status } = await axios.put(`${UPDATE_MARKETING_PROMOTION_BANNER_BY_ID_URL}/${id}`, body, {
            signal,
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateMarketingPromotionBannerById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateMarketingPromotionBannerById */

/**
 * @func deleteMarketingPromotionBannerById
 * @desc delete promotion banner by id
 * @author izeberg
 * @param {Object} body - create promotion banner body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} promotion banner array
 */
export const deleteMarketingPromotionBannerById = async (id, signal) => {
    try {
        const { status } = await axios.delete(`${DELETE_MARKETING_PROMOTION_BANNER_BY_ID_URL}/${id}`, {
            signal,
        });
        if (status === 200) {
            return true;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "deleteMarketingPromotionBannerById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func deleteMarketingPromotionBannerById */
